




































































































import {
  Vue, Component,
} from 'vue-property-decorator';
import BrandProductCard from '@/components/brand/BrandProductCard.vue';
import { ASSET_URL } from '../../common/config';
import ProductCOA from '../../common/model/ProductCOA';
import errorModule from '../../store/modules/error.module';
import productModule from '../../store/modules/product.module';
import brandModule from '../../store/modules/brand.module';
import budtenderModule from '../../store/modules/budtender.module';
import { CoaQueryPayload } from '../../common/write.types';

@Component({
  components: {
    BrandProductCard,
  },
})
export default class CoaSearchPage extends Vue {
  search = '';

  headers = [
    { text: 'METRC ID', value: 'title' },
    { text: 'Brand', value: 'brand.name' },
    { text: 'Product Name', value: 'product.title' },
    { text: 'Added', value: 'created_on' },
    { text: 'COA PDF', value: 'pdf_file' },
    { text: '', value: 'data-table-expand' },
  ];

  cdnUrl = ASSET_URL;

  placeholderImg = require('@/assets/admin/placeholder.jpg');

  get currentCoas(): Array<ProductCOA> {
    return productModule.productCOAs;
  }

  async searchQueryChanged(): Promise<void> {
    if (this.search.length < 5 || budtenderModule.brands.length === 0) { return; }
    const shelfBrandIds: Array<string> = budtenderModule.brands.map(brand => brand.id);
    const payload: CoaQueryPayload = { searchQuery: this.search, shelfBrands: shelfBrandIds };
    await productModule.searchCoaByQuery(payload);
    errorModule.clearError();
  }

  dateToString(dateString: string): string {
    const date = new Date(dateString);
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    return `${month}/${day}/${date.getFullYear()}`;
  }
}
